import Keycloak from "keycloak-js";

const keycloakConfig = window.__ENV__ || {};

const keycloak = new Keycloak({
  url: keycloakConfig.KEYCLOAK_URL || "",
  realm: keycloakConfig.KEYCLOAK_REALM || "",
  clientId: keycloakConfig.KEYCLOAK_CLIENT_ID || "",
});

if (!window.__ENV__) {
  console.error("Missing runtime config: window.__ENV__ is undefined. Check %PUBLIC_URL%/config/config.js loading.");
}

export default keycloak;
